import { customAxios } from './customAxios'

export function saveApprovazioneAdv(approvazione,idPratica) {
  const config = {
    params: { idPratica: idPratica },
    headers: {
      AuthToken: JSON.parse(localStorage.getItem('token')),
    },
  }

  const data = {
    "validazioneEsito": approvazione
  }


  const adeguataVerificaRequest = customAxios.post(
    '/'+process.env.REACT_APP_PATH_NEW_PREFIX+'/saveApprovazioneADV',
    data,
    config,
  )
  return adeguataVerificaRequest
}
